(function () {
  const HIDE_CLASS = "is-hidden-variant-thumb";
  const norm = (v) => (v || "").toString().trim().toLowerCase();

  function parseVariantTitle(title) {
    if (!title) return { size: "", modules: "" };
    const parts = title.split("/").map((p) => p.trim());
    return {
      size: norm(parts[0] || ""),
      modules: norm(parts[1] || ""),
    };
  }

  function getSelectedVariant() {
    const variantId =
      window.ShopifyAnalytics?.meta?.selectedVariantId?.toString() ||
      document.querySelector("input.product-variant-id")?.value;

    if (!variantId) return null;
    const variants = window.meta?.product?.variants;
    if (!variants) return null;
    return variants.find((v) => v.id.toString() === variantId.toString()) || null;
  }

  function getSwiper(className) {
    const el = document.querySelector(`.${className}`);
    return el?.swiper || null;
  }

  // Build a Set of media IDs that match the current size + modules
  function buildMatchingIds(size, modules) {
    const thumbs = document.querySelectorAll(".product__thumbs-item[data-size][data-modules]");
    const ids = new Set();
    thumbs.forEach((thumb) => {
      const tSize = norm(thumb.dataset.size);
      const tModules = norm(thumb.dataset.modules);
      const isTagged = tSize !== "" && tModules !== "";
      if (isTagged && tSize === size && tModules === modules) {
        ids.add(thumb.dataset.target);
      }
    });
    return ids;
  }

  // Find next slide index that matches, in a given direction (1 = forward, -1 = backward)
  function getNextMatchingIndex(slider, fromIndex, direction, matchingIds) {
    let i = fromIndex + direction;
    while (i >= 0 && i < slider.slides.length) {
      const mediaId = slider.slides[i]?.dataset?.mediaId;
      if (matchingIds.has(mediaId)) return i;
      i += direction;
    }
    return -1;
  }

  // Register main swiper navigation interceptor
  // Uses a flag on the slider to avoid registering multiple times per init cycle
  function registerMainSwiperInterceptor(slider, matchingIds) {
    // Remove previous listeners by cloning the event — Swiper doesn't support removeListener by reference easily
    // Instead we use a versioned flag to ignore stale closures
    const version = Date.now();
    slider._vtfVersion = version;

    slider.on("slideNextTransitionStart", function () {
      if (slider._vtfVersion !== version) return;
      const currentMediaId = slider.slides[slider.activeIndex]?.dataset?.mediaId;
      if (!matchingIds.has(currentMediaId)) {
        const next = getNextMatchingIndex(slider, slider.activeIndex, 1, matchingIds);
        if (next > -1) {
          slider.slideTo(next, 0, false);
        } else {
          // No more matching slides forward — bounce back to last matching
          const prev = getNextMatchingIndex(slider, slider.activeIndex, -1, matchingIds);
          if (prev > -1) slider.slideTo(prev, 0, false);
        }
      }
    });

    slider.on("slidePrevTransitionStart", function () {
      if (slider._vtfVersion !== version) return;
      const currentMediaId = slider.slides[slider.activeIndex]?.dataset?.mediaId;
      if (!matchingIds.has(currentMediaId)) {
        const prev = getNextMatchingIndex(slider, slider.activeIndex, -1, matchingIds);
        if (prev > -1) {
          slider.slideTo(prev, 0, false);
        } else {
          // No more matching slides backward — bounce to first matching
          const next = getNextMatchingIndex(slider, slider.activeIndex, 1, matchingIds);
          if (next > -1) slider.slideTo(next, 0, false);
        }
      }
    });
  }

  function filterThumbs() {
    const variant = getSelectedVariant();
    if (!variant) return;

    const { size, modules } = parseVariantTitle(variant.public_title);
    console.log("[VTF] Filtering for:", size, modules);

    const thumbSwiper = getSwiper("product__media-gallery-thumbails");
    const thumbs = document.querySelectorAll(".product__thumbs-item[data-size][data-modules]");

    if (!thumbs.length) return;

    let firstMatchIndex = -1;

    thumbs.forEach((thumb, i) => {
      const tSize = norm(thumb.dataset.size);
      const tModules = norm(thumb.dataset.modules);
      const isTagged = tSize !== "" && tModules !== "";
      const isMatch = isTagged && tSize === size && tModules === modules;

      thumb.classList.toggle(HIDE_CLASS, isTagged && !isMatch);

      const slide = thumb.closest(".swiper-slide");
      if (slide) {
        if (isTagged && !isMatch) {
          slide.style.display = "none";
          slide.classList.add("swiper-slide-hidden");
        } else {
          slide.style.display = "";
          slide.classList.remove("swiper-slide-hidden");
          if (firstMatchIndex === -1) firstMatchIndex = i;
        }
      }
    });

    // Update thumb swiper
    if (thumbSwiper) {
      thumbSwiper.update();
      if (firstMatchIndex > -1) thumbSwiper.slideTo(firstMatchIndex, 0);
    }

    // Register main swiper interceptor with updated matchingIds
    const mg = document.querySelector("media-gallery");
    const mainSlider = mg?.sliderInstance?.slider;
    if (mainSlider && size && modules) {
      const matchingIds = buildMatchingIds(size, modules);
      registerMainSwiperInterceptor(mainSlider, matchingIds);
    }
  }

  function watchVariantChanges() {
    const variantInput = document.querySelector("input.product-variant-id");
    if (variantInput) {
      const observer = new MutationObserver(() => {
        setTimeout(filterThumbs, 50);
      });
      observer.observe(variantInput, { attributes: true, attributeFilter: ["value"] });
    }

    document.addEventListener("click", (e) => {
      const swatch = e.target.closest(
        "[data-value], .swatch, .variant-swatch, .color-swatch, [data-option-value], .product__option-item"
      );
      if (swatch) setTimeout(filterThumbs, 150);
    });

    document.addEventListener("variant:changed", filterThumbs);
    document.addEventListener("variantChanged", filterThumbs);
  }

  function init() {
    console.log("[VTF] Initializing...");
    setTimeout(() => {
      filterThumbs();
      watchVariantChanges();
    }, 500);
  }

  document.addEventListener("DOMContentLoaded", init);
})();